export default {
  height: 22,
  width: 25,
  stroke: true,
  svg: `
  <svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.0625 3.4375C17.0625 2.09119 18.1537 1 19.5 1C20.8463 1 21.9375 2.09119 21.9375 3.4375C21.9375 4.78381 21.0913 6.6875 19.5 6.6875C17.875 6.6875 17.0625 4.78381 17.0625 3.4375Z"  stroke-width="2"/>
<path d="M23 13.5C23.5523 13.5 24 13.0523 24 12.5V11.5117C24 11.0383 23.7206 10.603 23.2624 10.362C22.533 9.97833 21.2685 9.5 19.5 9.5C17.7086 9.5 16.4524 9.97533 15.7305 10.3583C15.276 10.5997 15 11.0337 15 11.5043V12.5C15 13.0523 15.4477 13.5 16 13.5H23Z"  stroke-width="2"/>
<path d="M14 19.5C14 20.0523 13.5523 20.5 13 20.5H2C1.44772 20.5 1 20.0523 1 19.5V18.1436C1 17.1575 1.84067 16.2911 3.07025 16.0111C4.22111 15.7489 5.76956 15.5 7.5 15.5C9.20192 15.5 10.7597 15.7531 11.9236 16.0178C13.1554 16.2978 14 17.1636 14 18.1517V19.5Z"  stroke-width="2"/>
<path d="M4 8.13636C4 6.128 5.56695 4.5 7.5 4.5C9.43305 4.5 11 6.128 11 8.13636C11 10.1447 9.43305 12.5 7.5 12.5C5.56695 12.5 4 10.1447 4 8.13636Z"  stroke-width="2"/>
</svg>
`
}
